import React from 'react';
import { SearchEmptySuggestionsEmptyItemLabelTypography } from '../SearchSuggestionItem/style';
import { useSearchEmptySuggestionsListClassName } from './hooks';
import { SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX } from './constants';
import { SearchEmptySuggestionsItemLabel, SearchEmptySuggestionsListRoot } from './style';
export var SearchEmptySuggestionsList = function SearchEmptySuggestionsList(_ref) {
  var _ref$noResultsLabel = _ref.noResultsLabel,
      noResultsLabel = _ref$noResultsLabel === void 0 ? 'No results found' : _ref$noResultsLabel,
      className = _ref.className,
      theme = _ref.theme;
  var classOverride = useSearchEmptySuggestionsListClassName(SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX, className);
  return React.createElement(SearchEmptySuggestionsListRoot, {
    className: classOverride.Root,
    theme: theme
  }, React.createElement(SearchEmptySuggestionsItemLabel, {
    className: classOverride.ItemLabel,
    theme: theme
  }, React.createElement(SearchEmptySuggestionsEmptyItemLabelTypography, {
    className: classOverride.ItemLabelTypography,
    paragraph: true,
    medium: true,
    theme: theme
  }, noResultsLabel)));
};